// const API_URL = "chat/api/chat";

export const sendMessageToOpenAI = async message => {
  try {
    const response = await fetch("https://testapi.aristai.io/api/ai/flashcard", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({message}),
    });

    if (!response.ok) {
      throw new Error("API request failed");
    }

    const data = await response.json();
    return data.content || data; // Handle both template1/4/5 and JSON responses
  } catch (error) {
    console.error("Error calling API:", error);
    throw error;
  }
};
